import React from 'react'

import { Typography } from '~/components/elements/Typography'

export type SurveySettingsFormInputProps = React.PropsWithChildren<{
  label: string
}>

export const SurveySettingsFormInput = ({
  children,
  label,
}: SurveySettingsFormInputProps) => (
  <>
    <Typography fontSize={16} textAlign="end" variant="normal">
      {label}
    </Typography>

    {children}
  </>
)
